module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-05.afe77471.png";